import jquery from 'jquery'

// Set jQuery globally FIRST
window.jQuery = jquery
window.$ = jquery

// Configure jQuery to include CSRF token in all AJAX requests
jquery.ajaxSetup({
  beforeSend: function(xhr, settings) {
    // Only add CSRF token for same-origin requests
    if (!this.crossDomain) {
      const token = document.querySelector('meta[name="csrf-token"]')
      if (token) {
        xhr.setRequestHeader('X-CSRF-Token', token.content)
      }
    }
  }
})

